<template>
    <div class="progress-layout">
        <div class="progress-item" v-for="(item, index) in progress" :key="item.icon">
            <div class="icon-text-box">
                <div class="icon-blue-circle">
                    <i class="iconfont" :class="item.icon"></i>
                </div>
                <p id="icon-text">{{item.text}}</p>
            </div>
            <img id="arrow" v-if="index !== progress.length -1"
                src="@/assets/images/icon-arrow2x.png"
            />
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      progress: [{
      //   icon: 'iconqiyezhuce',
      //   text: '企业注册并认证'
      // }, {
        icon: 'iconxuanzechanpin',
        text: '选择产品/发起融资'
      }, {
        icon: 'iconyinhangshouli',
        text: '机构受理'
      }, {
        icon: 'iconshenhetongguo',
        text: '审核通过'
      }, {
        icon: 'iconqianyuefangkuan',
        text: '签约放款'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.progress-layout {
    height:fit-content;
    padding: 25px 0 80px 0;
    @include displayCenter;
    position: relative;
}
.progress-item {
    @include displayCenter;
}
#arrow {
    width:24px;
    height:18px;
    margin:0 58px;
}
.icon-text-box {
    @include displayCenter;
    flex-direction: column;
    .icon-blue-circle {
        width:80px;
        height:80px;
        background:linear-gradient(0deg,rgba(20,146,255,1),rgba(41,84,208,1));
        box-shadow:0px 0px 11px 1px rgba(199,199,199,0.4);
        border-radius:50%;
        color:white;
        @include displayCenter;
        i {
            font-size: 40px;
        }
    }
    #icon-text {
        position: absolute;
        bottom: 45px;
        @include text-24-400;
        color:rgba(102,102,102,1);
        line-height:25px;
        font-size: 18px;
    }
}

</style>
